import styles from './error-banner.module.scss'

export function ErrorBanner() {
  return (
    <div className={styles.banner} role="status" aria-live="polite">
      Couldn&apos;t refresh. Retrying.
    </div>
  )
}
